import { useMemo } from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import { useTranslation } from '@lyearn/i18n';
import { ActionMenu, ActionMenuItemType } from '@lyearn/molecules';

import { RemoveImageActionMenuProps } from './types';

const RemoveImageActionMenu: React.FC<RemoveImageActionMenuProps> = (props) => {
  const { onRemoveImage } = props;
  const { t } = useTranslation();

  const items: ActionMenuItemType[] = useMemo(
    () => [
      {
        id: 'remove-image',
        label: t('QuizCreator:RemoveImage'),
      },
    ],
    [t],
  );

  const onAction = useEvent(() => {
    onRemoveImage();
  });

  return <ActionMenu items={items} onAction={onAction} />;
};

export default RemoveImageActionMenu;
